import moment from 'moment'
import { secondToHourMinute, getDayOfWeekStr } from '@/utils/datetimeUtil'

export const attendanceTableMixin = {
  props: {
    attendances: {
      type: Array,
      default: null
    }
    // leaves: {
    //   type: Array,
    //   default: null
    // }
  },
  // computed: {
  //   attendanceWithLeaves: function () {
  //     if (this.attendances && this.attendances.length) {
  //       let attendanceWithLeaves = []
  //       this.attendances.forEach(attendance => {
  //         this.leaves = this.getLeaveRecords(attendance.attendanceDate)
  //         attendanceWithLeaves.push(attendance)
  //       })
  //       return attendanceWithLeaves
  //     } else {
  //       return []
  //     }
  //   }
  // },
  methods: {
    isHoliday: function (attendance) {
      if (attendance.holidayChinName) {
        return true
      }
      let dayOfWeek = moment(attendance.attendanceDate).day()
      return dayOfWeek === 0 | dayOfWeek === 6
    },
    dayOfWeek: function (dateStr) {
      let date = moment(dateStr)
      return getDayOfWeekStr(date, this.$i18n.locale, 'short')
    },
    secondToHourMinute: function (second) {
      if (second) {
        return secondToHourMinute(second, 'xh xm')
      } else {
        return '--'
      }
    }
  }
}
